import { Application } from 'stimulus'
import { Controller } from 'stimulus'

class PagosController extends Controller {
  static get targets() {
    return ['modalidadId', 'errores',
            'checkboxTarjeta', 'erroresTarjeta', 'stripePaymentMethodId',
            'checkboxPaypal', 'paypalPaymentId', 'paypalPayerId']
  }

  initialize() {
    this.iniciarStripe()
  }

  connect() {
    // TODO: should be moved to initialize and/or ensure that this controller isn't connected twice, at this moment
    // isn't working on paid webinars if moved to the intialize method
    this.iniciarPaypal()
  }

  iniciarStripe() {
    this.stripe = Stripe(this.data.get('stripe-key'))
    this.elements = this.stripe.elements({ locale: 'es' });
    this.card = this.elements.create('card', { hidePostalCode: true })
    this.card.mount('#tarjeta')
    this.card.addEventListener('change', (event) => {
      this.actualizadoStripe(event)
    })

    this.form.addEventListener('ajax:before', (event) => {
      if (this.stripePaymentMethodIdTarget.value === '' || !this.checkboxTarjetaTarget.checked) {
        event.preventDefault()
        return
      }

      document.body.dataset.loading = 'Procesando... No abandones ni recargues la página'
    })

    this.form.addEventListener('ajax:success', (event) => {
      const body = event.detail[0]
      if (body.requires_action) {
        this.handleStripeSca(body.client_secret)
      } else if (body.error) {
        this.showError(body.error)
      } else if (body.thank_you_page) {
        window.location.href = body.thank_you_page
      } else {
        console.error('Uh... Esto no debería pasar')
      }
    })
  }

  iniciarPaypal() {
    if (!this.element.offsetParent) {
      // The form is not visible yet, and bad things happen when PayPal renders to an invisible element.
      return
    }
    this.renderPaypalButton()
    this.form.addEventListener('change', () => {
      this.revalidarPaypal()
    })
  }

  actualizadoStripe(event) {
    this.checkboxTarjetaTarget.checked = false
    this.stripePaymentMethodId = ''

    if (event.error) {
      this.erroresTarjeta.textContent = event.error.message
    } else {
      this.erroresTarjeta.textContent = ''

      if (event.complete) {
        this.stripe.createPaymentMethod('card', this.card).then(result => {
          if (result.error) {
            this.erroresTarjeta.textContent = result.error.message
            return false
          } else {
            this.stripePaymentMethodId = result.paymentMethod.id
            this.markTarjetaAsChecked()

            this.clearErrors()
          }
        })
      }
    }
  }

  handleStripeSca(clientSecret) {
    this.stripe.handleCardPayment(clientSecret).then(result => {
      if (result.error) {
        if (result.error.code == 'payment_intent_authentication_failure') {
          this.showError('No hemos podido autenticar tu tarjeta. Por favor inténtalo de nuevo o elige otra tarjeta.')
        } else {
          this.showError('Se ha producido un error procesando el pago. No te preocupes: no te hemos cobrado nada.')
        }
      } else {
        const formData = new FormData(this.form)
        formData.append('stripe_payment_intent_id', result.paymentIntent.id)

        fetch(this.form.action, { method: 'POST', body: formData }).then(response => {
          response.json().then(body => {
            if (body.error) {
              this.showError(body.error)
            } else if (body.thank_you_page) {
              window.location.href = body.thank_you_page
            } else {
              console.error('Uh... Esto no debería pasar')
            }
          })
        })
      }
    })
  }

  renderPaypalButton() {
    const env = this.data.get('paypal-env')
    const client = {}
    client[env] = this.data.get('paypal-client-id')

    paypal.Button.render({
      env: env,
      locale: 'es_ES',
      client: client,

      style: {
        label: 'pay',       // checkout | pay | paypal
        size: 'responsive', // small | medium | large | responsive
        shape: 'rect',      // pill | rect
        color: 'gold'       // gold | blue | silver | white | black
      },

      payment: () => {
        let formData = new FormData()
        formData.append('ponencia_id', this.data.get('ponencia-id'))
        formData.append('modalidad_id', this.modalidadId)
        return fetch('/paypal/crea_pago', { method: 'POST', body: formData })
          .then(response => {
            if (response.ok) {
              return response.json().then(payment => payment.id)
            }
            response.json().then(error => {
              console.log(error)
              throw error
            })
          })
      },

      onAuthorize: (data) => {
        this.markPaypalAsChecked()
        this.paypalPaymentId = data.paymentID
        this.paypalPayerId = data.payerID

        document.body.dataset.loading = 'Procesando... No abandones ni recargues la página'
        fetch(this.form.action, { method: 'POST', body: new FormData(this.form) }).then(response => {
          response.json().then(body => {
            if (body.error) {
              this.showError(body.error)
            } else if (body.thank_you_page) {
              window.location.href = body.thank_you_page
            } else {
              console.error('Uh... Esto no debería pasar')
            }
          })
        })
      },

      validate: (actions) => this.validarPaypal(actions),
      onClick: () => this.form.reportValidity(),
      onError: (error) => console.log(error),

    }, '#paypal-button-container')
  }

  validarPaypal(actions) {
    this.form.checkValidity() ? actions.enable() : actions.disable()
    this.paypalActions = actions
  }

  revalidarPaypal() {
    this.form.checkValidity() ? this.paypalActions.enable() : this.paypalActions.disable()
  }

  markTarjetaAsChecked(value = true) {
    this.checkboxTarjetaTarget.checked = value
  }

  markPaypalAsChecked(value = true) {
    this.checkboxPaypalTarget.checked = value
  }

  showError(message) {
    delete document.body.dataset.loading
    this.erroresTarget.insertAdjacentHTML('beforeend', `<div class='rnk-Flash-danger'>${message}</div>`)
    this.erroresTarget.scrollIntoView()
  }

  clearErrors() {
    this.erroresTarget.innerHTML = ''
  }

  get modalidadId() {
    return this.hasModalidadIdTarget ? this.modalidadIdTarget.value : ''
  }

  get erroresTarjeta() {
    return this.erroresTarjetaTarget
  }

  set stripePaymentMethodId(id) {
    this.stripePaymentMethodIdTarget.value = id
  }

  set paypalPaymentId(value) {
    this.paypalPaymentIdTarget.value = value
  }

  set paypalPayerId(value) {
    this.paypalPayerIdTarget.value = value
  }

  get form() {
    // "Nuestro form" es el form de cualquier input. Cogemos paypalPaymentId mismamente.
    return this.paypalPaymentIdTarget.form
  }
}

const application = Application.start()
application.register('pagos', PagosController)
